import { ErrorLayout } from '@/components/layouts/ErrorLayout';
import { useNavigateToHome } from '@/hooks/useNavigateToHome';

export const Forbidden = () => {
  const { navigateToHome } = useNavigateToHome();

  return (
    <ErrorLayout
      titleKey="errors.page.forbiddenTitle"
      messageKey="errors.page.forbiddenMessage"
      backButtonTextKey="errors.page.backToLogin"
      onBackClick={navigateToHome}
    />
  );
};
